module.exports = __webpack_public_path__ + "static/media/streamlabs.fe0fb6df.svg";